import { Outlet } from "react-router-dom";
import Navbar from "@/shared/components/layout/Navbar";
import { PublicFooter } from "@/shared/components/layout/PublicFooter";

const PublicLayout = () => (
  <div className="app-layout">
    <Navbar />
    <main className="app-main">
      <div className="content-shell">
        <Outlet />
      </div>
    </main>
    <PublicFooter />
  </div>
);

export default PublicLayout;
